import * as yup from 'yup';

interface ContactDealerSchemaProps {
  lastName: {
    format: string;
    required: string;
    minLength: string;
    maxLength: string;
  };
  firstName: {
    format: string;
    required: string;
    minLength: string;
    maxLength: string;
  };
  email: {
    format: string;
    required: string;
  };
  requestType: {
    required: string;
  };
  phone: {
    required: string;
    minLength: string;
    maxLength: string;
  };
  requestDate: {
    required: string;
  };
  timeWindow: {
    required: string;
  };
}
const contactDealerSchema = (validationMsgs: ContactDealerSchemaProps) => {
  const {
    lastName,
    firstName,
    email,
    requestType,
    phone,
    requestDate,
    timeWindow,
  } = validationMsgs;

  const onlyLettersRegEx = new RegExp(/^([^0-9]*)$/);
  return yup.object({
    lastName: yup
      .string()
      .trim()
      .matches(onlyLettersRegEx, lastName.format)
      .required(lastName.required)
      .min(2, lastName.minLength)
      .max(75, lastName.maxLength),
    firstName: yup
      .string()
      .trim()
      .matches(onlyLettersRegEx, firstName.format)
      .required(firstName.required)
      .min(2, firstName.minLength)
      .max(75, firstName.maxLength),
    email: yup.string().email(email.format).required(email.required),
    requestType: yup.string().trim().required(requestType.required),
    phone: yup
      .string()
      .min(4, phone.minLength)
      .max(20, phone.maxLength)
      .when('requestType', {
        is: (requestType: string) => requestType === 'CALLBACK',
        then: yup.string().required(phone.required),
      }),
    requestDate: yup.string().when('requestType', {
      is: (requestType: string) =>
        requestType === 'VIDEOCALL' || requestType === 'CALLBACK',
      then: yup.string().required(requestDate.required).nullable(),
    }),
    requestTimeWindow: yup.string().when('requestType', {
      is: (requestType: string) =>
        requestType === 'VIDEOCALL' || requestType === 'CALLBACK',
      then: yup.string().required(timeWindow.required),
    }),
  });
};
export default contactDealerSchema;
